export default __webpack_public_path__ + "static/media/claim.862dfe72.png";